import { SUPPORTED_LANGUAGES, SupportedLanguage } from '../constants/Languages.constants';

export function normalizeLanguageCode(lang?: string): SupportedLanguage {
    if (!lang) return 'en';
    const code = lang.slice(0, 2).toLowerCase();
    return (SUPPORTED_LANGUAGES.includes(code as SupportedLanguage) ? code : 'en') as SupportedLanguage;
}

export function isSupportedLanguage(lang?: string): boolean {
    if (!lang) return false;
    return SUPPORTED_LANGUAGES.includes(lang.slice(0, 2).toLowerCase() as SupportedLanguage);
}
